import Hdr from '../shared/Hdr'
import React from 'react'
import swal from 'sweetalert';
import { useState, useEffect } from 'react';
import { apiPath1, apiPath2 } from "../services/apiConfig";
//import {Link} from 'react-router-dom';
import TopBanner from '../components/TopBanner';
import { motion, AnimatePresence } from "framer-motion";

import ExcelExport from '../components/ExcelExport';

function ToolMaster() {

  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const user_id = localStorage.getItem('user-id');
  const usrName = localStorage.getItem('userName');
  const dept_id = localStorage.getItem('dept-id');
  const dept_name = localStorage.getItem('dept-name');

  //const [department_name,setDepartment]=useState("");
  //const [section_name,setSecName]=useState("");
  const [toolName, setToolName] = useState("");
  const [toolTag, setToolTag] = useState("");
  //const [secName,setSectionName]=useState("");
  const [display, setDisplay] = useState(false);
  const [dispSearch,setDisplaySearch] = useState('block')
  const [displayUpdate, setDisplayUpdate] = useState(false);
  const [displayView, setDisplayView] = useState(false);
  const [displayUpdSec, setDisplayUpdsec] = useState('none');
  const [data, setData] = useState([]);
  //const [section,setSection]=useState([]);
  const [toolsID, setToolsID] = useState('')
  //const [secID,setSecID]=useState('')
  //const [secStat,setSecStat] = useState()

  const [categoryData, setCategoryData] = useState([])
  const [uom, setUOM] = useState()
  const [purdate, setPurDate] = useState('')
  const [repdate, setRepDate] = useState('')
  const [cpu, setCPU] = useState('')
  const [qty, setQTY] = useState()
  const [status, setStatus] = useState()
  const [category, setCategory] = useState()
  const [toolcode, setToolCode] = useState()
  const [description, setDescription] = useState('')

  const [updToolName, setUpdToolName] = useState()
  const [updToolTag, setUpdToolTag] = useState()

  const [updToolCode, setUpdToolCode] = useState()
  const [upddescription, setupdDescription] = useState()
  const [updcategoryID, setupdCategoryId] = useState()
  const [updUom, setupdUOM] = useState()
  const [updCPU, setupdCPU] = useState()
  const [updDop, setupdDOP] = useState()
  const [updQty, setupdQty] = useState()
  const [calibration,setCalibration] = useState()
  const [updStatus, setupdStatus] = useState()
  const [updDor, setupdDOR] = useState('')
  const [updToolId, setupdToolID] = useState()
  const [updToolType, setupdToolType] = useState()
  const [updCalibration, setupdCalibration] = useState()
  const [tooltype, setToolType] = useState()
  // const [dop,setDop]=useState()
  // const [dor,setDor]= useState()

  const [dispSearchCategory, setDispSearchCategory] = useState('none')
  const [dispSearchStatus, setDispSearchStatus] = useState('none')
  const [dispSearchType, setDispSearchType] = useState('none')
  const [dispSearchName, setDisplaySearchName] = useState('none')
  const [dispSearchDescription, setDispSearchDescription] = useState('none')
  const [selectedCategory, SetSelectedCategory] = useState('0')
  const [selectedStatus, setSelectedStatus] = useState('0')
  const [selectedType, SetSelectedType] = useState('0')
  const [searchType, setSearchType] = useState('')
  const [uomList, setUOMList] = useState([])

  const [selectedCategoryValue, setSelectedCategoryValue] = useState('0')
  const [selectedToolValue, setSelectedToolValue] = useState('0')
  const [selectedStatusValue,setSelectedStatusValue] = useState('0')
  const [selectedUOM, setSelectedUOM] = useState('0')
  const [selectedPurDt, setSelectedPurDt] = useState('')
  const [selectedRepDt, setSelectedRepDt] = useState('')

  const [initCategoryValue, setInitCategoryValue] = useState('0')
  const [searchNameString, setSearchNameString] = useState('')
  const [searchDescripString,setSearchDescripString]  = useState('')

  const [checkedValue, setCheckedValue] = useState(false)
  const [categoryName,setupdCategoryName] = useState('')
  const [requireCalibration,setupdRequireCalibration] = useState(0)

  useEffect(() => {
    getData()
//    getToolCategory()
    getToolCategorySearch()
    getUOM()
    getDept()
  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

  /* DELETE OPERATION */

  function deleteOperation(id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          DeleteTools(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  /* final CATAGORY deletion*/
  async function DeleteTools(props) {

    let result = await fetch(apiPath1 + "ToolDelete/" + props,
      {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    getData()

  }


  /* FIND CATAGORY RECORD ON THE BASIS OF CATAGORY ID*/

  async function updateOperation(id) {


    let result = await fetch(apiPath1 + "Tool/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

     

    result = await result.json();

   // alert(result.data[0].tool_type)

    setUpdToolName(result.data[0].tool_name);
    setUpdToolTag(result.data[0].tool_tag);
    setUpdToolCode(result.data[0].tool_code);
    setupdDescription(result.data[0].tool_description)
    setupdCategoryId(result.data[0].tool_category_id)
    setupdCategoryName(result.data[0].tool_category_name)
    setupdUOM(result.data[0].uom)
    setupdCPU(result.data[0].cpu)
    setupdCalibration(result.data[0].require_calibration)
    if (result.data[0].dop) { setupdDOP((result.data[0].dop).substr(0, 10)) }
    setupdQty(result.data[0].quantity)
    setupdStatus(result.data[0].status)
    if (result.data[0].dor) { setupdDOR((result.data[0].dor).substr(0, 10)) }
    setupdToolType(result.data[0].tool_type)
   // setupdRequireCalibration(result.data[0].require_calibration)
    setupdCalibration(result.data[0].require_calibration)


    setupdToolID(id)

    openUpdateTools()

  }

  async function View(id) {

    let result = await fetch(apiPath1 + "Tool/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdToolName(result.data[0].tool_name);
    setUpdToolTag(result.data[0].tool_tag);
    setUpdToolCode(result.data[0].tool_code);
    setupdDescription(result.data[0].tool_description)
    setupdCategoryId(result.data[0].tool_category_id)
    setupdCategoryName(result.data[0].tool_category_name)
    setupdUOM(result.data[0].uom)
    setupdCPU(result.data[0].cpu)
    if (result.data[0].dop) { setupdDOP((result.data[0].dop).substr(0, 10)) }
    setupdQty(result.data[0].quantity)
    setupdStatus(result.data[0].status)
    setupdToolType(result.data[0].tool_type)
    if (result.data[0].dor) { setupdDOR((result.data[0].dor).substr(0, 10)) }

    openView()

  }

  /* LIST OF ALL TOOLS (for initial screen) */

  async function getData() {

    let result = await fetch(apiPath1 + "Tools",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }


  /* LIST OF ALL UOM (for initial screen) */
  async function getUOM() {

    let result = await fetch(apiPath1 + "UomList",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();


    if (result.status === true) { setUOMList(result.data) }
    else { setUOMList([]) }
  }


  function openTools() {
    setDisplay(true)
  }

  function closeTools() {
    clearTransaction()
    setDisplay(false)
  }

  function openView() {
    setDisplayView(true)
  }

  function closeView() {
    setDisplayView(false)
  }

  function openUpdateTools() {
    setDisplayUpdate(true)
  }

  function closeUpdateTools() {
    setDisplayUpdate(false)
  }

  function toolsHandler(e) {
    e.preventDefault()
    setToolName(e.target.value)
  }

  function toolsTagHandler(e) {
    e.preventDefault()
    setToolTag(e.target.value)
  }

  function setNameString(e){
    e.preventDefault()
    setSearchNameString(e.target.value)
  }

  function setDescripString(e){
  //  alert(e.target.value)
    e.preventDefault()
    setSearchDescripString(e.target.value)
  }

  function purDtHandler(e) {
    e.preventDefault()
    setSelectedPurDt(e.target.value)
    setPurDate(e.target.value)
  }

  function repDtHandler(e) {
    e.preventDefault()
    setSelectedRepDt(e.target.value)
    setRepDate(e.target.value)
  }

  function toolTypeHandler(e) {
   // alert(e.target.options[e.target.selectedIndex].text)
    e.preventDefault()
    setSelectedToolValue(e.target.value)
    setToolType(e.target.options[e.target.selectedIndex].text)
    getToolCategory(e.target.value)
  }

  function categoryHandler(e) {
    e.preventDefault()
    setSelectedCategoryValue(e.target.value)
    setCategory(e.target.value)
  }

  function updcategoryHandler(e) {
    e.preventDefault()
    setupdCategoryId(e.target.value)
  }

  function cpuHandler(e) {
    e.preventDefault()
    setCPU(e.target.value)
  }

  function UOMHandler(e) {
    e.preventDefault()
    setSelectedUOM(e.target.value)
    setUOM(e.target.value)
  }

  function cpuUpdHandler(e) {
    e.preventDefault()
    setupdCPU(e.target.value)
  }

  function qtyHandler(e) {
    e.preventDefault()
    setQTY(e.target.value)
  }

  function updqtyHandler(e) {
    e.preventDefault()
    setupdQty(e.target.value)
  }

  function toolCodeHandler(e) {
    e.preventDefault()
    setToolCode(e.target.value)
  }

  function updtoolCodeHandler(e) {
    e.preventDefault()
    setUpdToolCode(e.target.value)
  }

  function updtoolTypeHandler(e) {
    e.preventDefault()
    setupdToolType(e.target.value)
  }

  function updateToolsHandler(e) {
    e.preventDefault()
    setUpdToolName(e.target.value)
  }

  function updateToolsTagHandler(e) {
    e.preventDefault()
    setUpdToolTag(e.target.value)
  }

  function descHandler(e) {
    e.preventDefault()
    setDescription(e.target.value)

  }

  function upddescHandler(e) {
    e.preventDefault()
    setupdDescription(e.target.value)
  }

  /* ADDING NEW CATAGORY*/

  async function addTools() {

    //alert(toolName + ', ' + description + ', ' + category + ', ' + tooltype + ', '
    //  + uom + ', ' + cpu + ', ' + purdate + ', ' + repdate)


    let result = await fetch(apiPath1 + "ToolAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "tool_name": toolName,
        "tool_tag": toolTag,
        "tool_description": description,
        "tool_category_id": category,
        "tool_type": tooltype,
        "uom": uom,
        "cpu": cpu,
        "dop": purdate.toString(),
        "dor": repdate.toString(),
        "require_calibrartion" : calibration,
        "dept_id":selectedDept
      })
    });
    result = await result.json();

    showSwal(result.status, result.msg)

    clearTransaction()
    getData()

  }

  /* MODIFY A TOOLS,    */

  async function updateTools() {

    //  alert(updToolId+', '+updToolCode+','+updToolName+','+
    //    upddescription+','+updcategoryID+','+updToolType+','+
    //    updUom+','+updCPU+','+updDop+','+updQty+','+updStatus+','+updDor+','+user_id)

    // alert(updCalibration)

    let result = await fetch(apiPath1 + "ToolUpdate", {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": updToolId,
        "tool_code": updToolCode,
        "tool_name": updToolName,
        "tool_tag" : updToolTag,
        "tool_description": upddescription,
        "tool_category_id": updcategoryID,
        "tool_type": updToolType,
        "uom": updUom,
        "cpu": updCPU,
        "dop": updDop,
        "quantity": updQty,
        "status": updStatus,
        "dor": updDor,
        "user_id": user_id,
        "require_calibration":updCalibration 

      })
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeUpdateTools();
    getData()

  }

  const [searchCategoryData, setSearchCategoryData] = useState([])


  /* LIST OF ALL TOOL CATAGORY List */

  async function getToolCategorySearch() {

    let result = await fetch(apiPath1 + "ToolCategories",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setSearchCategoryData(result.data) }
    else { setSearchCategoryData([]) }
  }


  async function getToolCategory(id) {

    let result = await fetch(apiPath1 + "ToolCategoriesByToolTypeId/"+id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryData(result.data) }
    else { setCategoryData([]) }
  }


  function handleSearchType(e) {


    setSearchType(e.target.value)

    if (e.target.value === '0') {
      setDisplaySearch('block')
      setDispSearchCategory('none')
      setDispSearchType('none')
      setDispSearchStatus('none')
      setDisplaySearchName('none')
      setDispSearchDescription('none')
      initSearchType()
    }


    if (e.target.value === 'Category') {
      setDispSearchCategory('block')
      setDispSearchType('none')
      setDispSearchStatus('none')
      setDisplaySearch('none')
      setDisplaySearchName('none')
      setDispSearchDescription('none')
    }
    if (e.target.value === 'Type') {
      setDispSearchType('block')
      setDispSearchCategory('none')
      setDispSearchStatus('none')
      setDisplaySearch('none')
      setDisplaySearchName('none')
      setDispSearchDescription('none')
    }
    if (e.target.value === 'Status') {
      setDispSearchStatus('block')
      setDispSearchType('none')
      setDispSearchCategory('none')
      setDisplaySearch('none')
      setDisplaySearchName('none')
      setDispSearchDescription('none')
    }

    if (e.target.value === 'Name') {
      //alert('name')
      setDisplaySearchName('block')
      setDispSearchStatus('none')
      setDispSearchType('none')
      setDispSearchCategory('none')
      setDisplaySearch('none')
      setDispSearchDescription('none')
    }


    if (e.target.value === 'Description') {
      //alert('Description')
      setDispSearchDescription('block')
      setDisplaySearchName('none')
      setDispSearchStatus('none')
      setDispSearchType('none')
      setDispSearchCategory('none')
      setDisplaySearch('none')
    }

  }

  function initSearchType(){
   // alert('here')
    SetSelectedCategory('0')
    SetSelectedType('0')
    setSelectedStatus('0')
    setSearchNameString('')
    setSearchDescripString('')
  }


  var filterApi = '';

  function filterData() {

   //alert(searchType)

    if (searchType === '0') {
      getData()
      return
    }

    if (searchType === "Category") {
      filterApi = 'ToolCategoryWise/' + selectedCategory
      getFilterData(filterApi)
    }
    if (searchType === "Type") {
      filterApi = 'ToolTypeWise/' + selectedType
      getFilterData(filterApi)
    }
    if (searchType === "Status") {
      filterApi = 'ToolStatusWise/' + selectedStatus
      getFilterData(filterApi)
    }

    if (searchType === "Name"){
      filterApi = 'ToolsLike/' + searchNameString
      getFilterData(filterApi)
    }

    if (searchType === "Description"){
      filterApi = 'ToolsLikeDesc/' + searchDescripString
      getFilterData(filterApi)
    }
    
  }


  async function getFilterData(filterString) {

    //alert(filterString)

    let result = await fetch(apiPath1 + filterString,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  function clearTransaction() {

    setSelectedCategoryValue('0')
    setSelectedToolValue('0')
    setSelectedUOM('0')
    setSelectedPurDt('')
    setSelectedRepDt('')
    setToolName('')
    setToolTag('')
    setDescription('')
    setCPU('')
    setCalibration(false)
    setCheckedValue(false)

    setCategoryData([])
  }


  function handleCalibration(e){
    if (checkedValue === true) {
      setCheckedValue(false)
    }else{
      setCheckedValue(true)
    }
  //  alert(e.target.checked)
    setCalibration(e.target.checked)
   
  }

  function handleUpdateCalibration(e){
   
    if (e.target.checked === true){
        setupdCalibration(1)
    }else{
        setupdCalibration(0)
    }
   
  }

  //function handleChange(e){
  //  alert(e.target.value)
  //}

  //function initAddToolData(){

  //}

  const [deptList, setDeptList] = useState()
  const [selectedDept, setSelectedDept] = useState()

  async function getDept(){

    let result = await fetch(apiPath1 + "DepartmentHasTools",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();


    if (result.status === true) { setDeptList(result.data) }
    else { setDeptList([]) }

  }


  function deptHandler(e){
    setSelectedDept(e.target.value)
  }

  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Tools Master'} />

      <div className="row p16 " style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* CTA SECTION */}
          <div className="row mb16">
            {/* SELECT FILTER SECTION */}
            <div className="c12-l-7">
              <div className='row'>
                <div className="c12-l-3 px4">
                  <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Search Field</p>
                  <select className="small"
                    onChange={handleSearchType}
                    style={{ 'marginTop': '1px' }}>
                    <option value='0'>Open List</option>
                    <option value="Category">Tool Category</option>
                    <option value="Type">Tool Type</option>
                    <option value="Status">Tool Status</option>
                    <option value="Name">Tool Name</option>
                    <option value="Description">Tool Description</option>
                  </select>
                </div>

                <div className="c12-l-3" style={{ 'marginLeft': '4px', 'display': dispSearch }} >
                  <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Search</p>
                  <select className="small" onChange={(e) => SetSelectedCategory(e.target.value)}
                    style={{ 'marginTop': '1px' }}>
                    <option value='0'>Open List</option>
                  </select>
                </div>

                <div className="c12-l-3" style={{ 'marginLeft': '4px', 'display': dispSearchName }} >
                <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Tool Name</p>
                  <input type="text" className="box small" style={{ "marginTop": "0px" }} value={searchNameString}
                  placeholder="Name of the Tools" onChange={setNameString} />
                </div>
                
                <div className="c12-l-3" style={{ 'marginLeft': '4px', 'display': dispSearchDescription }} >
                <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Tool Description</p>
                  <input type="text" className="box small" style={{ "marginTop": "0px" }} value={searchDescripString}
                  placeholder="Tool Description" onChange={setDescripString} />
                </div>

                <div className="c12-l-3" style={{ 'marginLeft': '4px', 'display': dispSearchCategory }} >
                  <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Tool Category</p>

                  <select className="small" onChange={(e) => SetSelectedCategory(e.target.value)}
                    style={{ 'marginTop': '1px' }} value={selectedCategory}>
                    <option value='0'>Open List</option>
                    {
                      searchCategoryData.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.category_name}</option>
                      )
                    }
                  </select>
                </div>

                <div className="c12-l-3" style={{ 'marginLeft': '4px', 'display': dispSearchStatus }} >
                  <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Tool Status</p>

                  <select className="small"
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    style={{ 'marginTop': '1px' }} value ={selectedStatus}>
                    <option value="0">Open List</option>
                    <option value="OK">OK</option>
                    <option value="in-Repair">Require Repair</option>
                    <option value="Damaged">Damage</option>
                  </select>
                </div>

                <div className="c12-l-3" style={{ 'marginLeft': '4px', 'display': dispSearchType }} >
                  <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Select Tool Type</p>

                  <select className="small"
                    onChange={(e) => SetSelectedType(e.target.value)}
                    style={{ 'marginTop': '1px' }} value={selectedType}>
                    <option value="0">Open List</option>
                    <option value="Tool">Tool</option>
                    <option value="Heavy Tool">Heavy Tool</option>
                    <option value="Consumable">Consumable</option>
                  </select>
                </div>

                <div className="c12-l-3" style={{ 'marginLeft': '2px', 'marginTop': '14px' }}>
                  <button onClick={filterData} className="btn gradient round" 
                  type="button" name="SearchBtn">Search</button>
                </div>
                
                {/*Export to XL Button*/}
                <div className="c12-l-1" style={{'marginTop': '18px', 'width':'30px'}}>
                  <ExcelExport data={data} fileName="ToolMaster" />
                </div>
              </div>
            </div>
            <div className="c12-l-3"></div>

            {/* ADD BUTTON */}
            <div className="c12-l-2 align-bottom-right">
              <button onClick={openTools} type="button" name="button"
                className="btn large gradient round">Add New Tool</button>
                <div>{display}</div>
            </div>
          </div>
          
          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '86%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
                  <th className="th-border" width="10%">Tool Code</th>
                  <th className="th-border left" width="10%">Tool Tag</th>
                  <th className="th-border left" width="20%">Tool Name</th>
                  <th className="th-border left" width="20%">Tool Description</th>
                  <th className="th-border left" width="10%">Type</th>
                  <th className="th-border left" width="25%">Category</th>
                  <th className="th-border left" width="15%">Department</th>
                  <th className="th-border center" width="15%">Quantity</th>
                  <th className="th-border left" width="10%">UOM</th>
                  <th className="th-border left" width="10%">Cost/Unit</th>
                  <th className="th-border left" width="15%">Calibration</th>
                  <th className="th-border left" width="15%">Status</th>
                  <th className="th-border" width="5%">View</th>
                  <th className="th-border" width="5%">Edit</th>
                  <th className="th-border" width="15%">Delete</th>
                </tr>
              </thead>
              <tbody>
                {
                  data.map((item, index) =>
                    <tr className="tr-two-color-grey" key={index}>
                      <td className="center">{item.tool_code}</td>
                      <td className="">{item.tool_tag}</td>
                      <td className="">{item.tool_name}</td>
                      <td className="">{item.tool_description}</td>
                      <td className="">{item.tool_type}</td>
                      <td className="">{item.tool_category_name}</td> 
                      <td className="">{item.dept_name}</td> 
                      <td className="center">{item.quantity}</td>
                      <td className="">{item.uom}</td>
                      <td className="right">{item.cpu}</td>
                      {
                        (item.require_calibration === 1 ?
                      <td className="center"><img src={require('../asset/icons/check_tick.png')} alt="" /></td>
                      :<td></td> )
                      } 
                      <td className="">{item.status}</td>
                      <td onClick={() => { View(item.id) }} className="center"><img src={require('../asset/icons/adm_view_16.png')} alt="" /></td>
                      <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                      <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>

          
        {/* SCREEN FROM ADDING NEW TOOLS */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {display && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTools" 
            className="cont__add-sm">
            
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-9">
                  <h3 className='txt-subtlewhite'>Add Tools</h3><br />
                </div>
                <div className="c12-l-2"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeTools}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt16 px16">
                <div className="c12-l-12">

                  <div className="row">
                  {
                    (dept_id ===  '4' ?
                      (
                        <div className="c12-l-12">
                          <p>Department</p>
                          <select className="small" onChange={deptHandler} style={{ "marginTop": "0px" }}>
                            <option value="0" >Select Department</option>
                            {
                              deptList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.dept_name}</option>
                              )
                            }
                          </select>
                        </div>
                      ):<div className="c12-l-12">
                          <p>Department</p>
                          <input type="text" className="box small"
                          value={dept_name} style={{ "marginTop": "0px" }} />
                        </div>)
                    }
                  </div>

                  <div className="row">
                    <div className="c12-l-6">
                      <p>Type</p>
                      <select className="small" value={selectedToolValue} style={{ 'marginTop': '0px' }} onChange={toolTypeHandler}>
                        <option value="0">Select Type</option>
                        <option value="1">Heavy Tool</option>
                        <option value="2">Tool</option>
                        <option value="3">Consumable</option>
                      </select>
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-5"></div>
                  </div>                 

                  <div className="row">
                    <div className="c12-l-6">
                    
                      <p>Select Tool Catagory</p>
                      <select className="small" value={selectedCategoryValue} onChange={categoryHandler} style={{ "marginTop": "0px" }}>
                        <option value="0" >Select Catagory</option>
                        {
                          categoryData.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.category_name}</option>
                          )
                        }
                      </select>
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-5"></div>
                  </div> <br />

                  <div className="row">
                    <div className="c12-l-6">
                      <p style={{ "fontSize": ".65rem" }}>Name</p>
                      <input type="text" value={toolName} className="box small" style={{ "marginTop": "0px" }}
                        placeholder="Name of the Tools" onChange={toolsHandler} />
                    </div>
                    <div className="c12-l-1">
                    </div>
                    <div className="c12-l-5">
                      <p style={{ "fontSize": ".65rem" }}>Tool Tag</p>
                      <input type="text" value={toolTag} className="box small" style={{ "marginTop": "0px" }}
                        placeholder="Indentication" onChange={toolsTagHandler} />

                    </div>
                  </div>

                  <p style={{ "fontSize": ".65rem" }}>Description</p>
                  <textarea type="text" value={description} className="box small" style={{ "marginTop": "0px" }}
                    placeholder="Description" onChange={descHandler} />

                  <div className="row">
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>UOM</p>
                      <select value={selectedUOM} className="small" onChange={UOMHandler} style={{ 'marginTop': '0px' }}>
                        <option value="0">Select UOM</option>
                        {
                          uomList.map((item, index) =>
                            <option key={item.id} value={item.uom}>{item.uom}</option>
                          )
                        }
                      </select>

                      <label>
                        <p style={{ "fontSize": ".65rem" }}>Require Calibration</p> 
                        <input checked={checkedValue} type="checkbox" onChange={handleCalibration} /> 
                      </label>

                    </div>
                    <div className="c12-l-2"></div>
                    <div className="c12-l-6">

                      <p style={{ "fontSize": ".65rem" }}>Dt.of Pur/Hire</p>
                      <input type="date" value={selectedPurDt} className="custom__date" onChange={purDtHandler} style={{ "marginTop": "0px" }} />

                      <p style={{ "fontSize": ".65rem" }}>Dt.of Repair</p>
                      <input type="date" value={selectedRepDt} className="custom__date" onChange={repDtHandler} style={{ "marginTop": "0px" }} />

                    </div>
                  </div>

                  <button onClick={addTools} type="button" name="button"
                    className="btn gradient round">Add Tools</button>
                </div>
              </div>
              
            </form>
          </motion.div>
        )}
        </AnimatePresence>

        {/* SCREEN FROM MODIFYING TOOLS */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayUpdate && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="updateTools" className="cont__add-sm">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-9">
                  <h3 className='txt-subtlewhite'>Update Tools</h3><br />
                </div>
                <div className="c12-l-2"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdateTools}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className="c12-l-7">
                      <p style={{ "fontSize": ".65rem" }}>Select Tool Catagory</p>
                      {/*
                      <select className="small" value={updcategoryID} onChange={updcategoryHandler} style={{ "marginTop": "0px" }}>
                        <option value="0" >Select Catagory</option>
                        {
                          categoryData.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.category_name}</option>
                          )
                        }
                      </select>
                      */}
                      <input type="text" className="box small" value={categoryName} style={{ "marginTop": "0px" }} />
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>Tool Code</p>
                      <input type="text" className="box small"
                        placeholder="Tool Code" value={updToolCode} style={{ "marginTop": "0px" }} />
                    </div>
                  </div>

                  <div className="row">
                    <div className="c12-l-7">
                      <p style={{ "fontSize": ".65rem" }}>Name</p>
                      <input type="text" className="box small" style={{ "marginTop": "0px" }}
                        placeholder="Name of the Tools" value={updToolName} onChange={updateToolsHandler}
                      />
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>Type</p>
                      {/*
                      <select className="small" style={{ 'marginTop': '0px' }}
                        onChange={(e) => setupdToolType(e.target.value)} value={updToolType}>
                        <option value="Heavy Tool">Heavy Tool</option>
                        <option value="Tool">Tool</option>
                        <option value="Consumable">Consumable</option>
                      </select>
                      */}
                      <input type="text" className="box small" style={{ "marginTop": "0px" }} value={updToolType} />

                    </div>
                  </div>

                  <div className="row">
                    <div className="c12-l-7">
                      <p style={{ "fontSize": ".65rem" }}>Tool Tag</p>
                      <input type="text" className="box small" style={{ "marginTop": "0px" }}
                        placeholder="Identification" value={updToolTag} onChange={updateToolsTagHandler}
                      />
                    </div>
                    <div className="c12-l-5"></div>
                  </div>
                                    
                  <p style={{ "fontSize": ".65rem" }}>Description</p>
                  <textarea type="text" className="box small" rows="3" style={{ "marginTop": "0px" }}
                    placeholder="Description" value={upddescription} onChange={upddescHandler} />

                  <div className="row">
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>UOM</p>

                      <select value={updUom} className="small" onChange={(e) => setupdUOM(e.target.value)} style={{ 'marginTop': '0px' }}>
                        <option value="0">Select UOM</option>
                        {
                          uomList.map((item, index) =>
                            <option key={item.id} value={item.uom}>{item.uom}</option>
                          )
                        }
                      </select>

                      <p style={{ "fontSize": ".65rem" }}>cost per unit</p>
                      <input type="text" className="box small" value={updCPU} style={{ "marginTop": "0px" }}
                        placeholder="Cost per unit" onChange={cpuUpdHandler} />

                    </div>
                    <div className="c12-l-2"></div>
                    <div className="c12-l-4">

                      <p style={{ "fontSize": ".65rem" }}>Dt.of Pur/Hire</p>
                      <input type="date" className="custom__date" value={updDop} style={{ "marginTop": "0px" }}
                        onChange={(e) => setupdDOP(e.target.value)} />

                      <p style={{ "fontSize": ".65rem" }}>Dt.of Repair</p>
                      <input type="date" className="custom__date" placeholder="Start Date" style={{ "marginTop": "0px" }}
                        onChange={(e) => setupdDOR(e.target.value)} value={updDor} />

                        {
                          updToolType === 'Heavy Tool' &&
                          <label>
                            <p style={{ "fontSize": ".65rem" }}>Require Calibration</p> 
                            <input checked={updCalibration} type="checkbox" onChange={handleUpdateCalibration} /> 
                          </label>
                        }

                    </div>
                  </div><br/>
                  <button className="btn gradient round large" type="button" onClick={() => { updateTools() }}>Update Tools</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* SCREEN FROM VIEW TOOLS */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayView && (
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="updateTools" className="cont__add-sm">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-11">
                  <h3 className='txt-subtlewhite'>View Tools Details</h3><br />
                </div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeView}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className="c12-l-7">
                      <p style={{ "fontSize": ".65rem" }}>Select Tool Catagory</p>
                      {/*
                      <select className="small" value={updcategoryID} onChange={updcategoryHandler}>
                        <option value="0" >Select Catagory</option>
                        {
                          categoryData.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.category_name}</option>
                          )
                        }
                      </select>
                      */}
                      <input type="text" className="box small" value={categoryName} style={{ "marginTop": "0px" }} />
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>Tool Code</p>
                      <input type="text" className="box small"
                        placeholder="Tool Code" value={updToolCode} style={{ "marginTop": "0px" }} />
                    </div>
                  </div>

                  <div className="row">
                    <div className="c12-l-7">
                      <p style={{ "fontSize": ".65rem" }}>Name</p>
                      <input type="text" className="box small"
                        placeholder="Name of the Tools" value={updToolName} style={{ "marginTop": "0px" }}
                      />
                    </div>
                    <div className="c12-l-1"></div>
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>Type</p>
                      <input type="text" className="box small" style={{ "marginTop": "0px" }} value={updToolType} />
                      
                    </div>
                  </div>

                  <p style={{ "fontSize": ".65rem" }}>Description</p>
                  <textarea type="text" className="box small" rows="3" style={{ "marginTop": "0px" }}
                    placeholder="Description" value={upddescription} />

                  <div className="row">
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>UOM</p>
                      <input type="text" className="box small" style={{ "marginTop": "0px" }} value={updUom} />
                      {/*
                      <select className="small" value={updUom} onChange={(e) => setupdUOM(e.target.value)} style={{ "marginTop": "0px" }}>
                        <option value="kg">kg</option>
                        <option value="gm">gm</option>
                        <option value="ltr">ltr</option>
                        <option value="ml">ml</option>
                        <option value="pc">pc</option>
                        <option value="box">box</option>
                        <option value="carton">carton</option>
                        <option value="no">no</option>
                      </select>
                      */}
                      <p style={{ "fontSize": ".65rem" }}>cost per unit</p>
                      <input type="text" className="box small" value={updCPU} style={{ "marginTop": "0px" }} />

                      <p style={{ "fontSize": ".65rem" }}>Dt.of Pur/Hire</p>
                      <input type="date" className="custom__date" value={updDop} style={{ "marginTop": "0px" }} />

                    </div>
                    <div className="c12-l-2"></div>
                    <div className="c12-l-4">
                      <p style={{ "fontSize": ".65rem" }}>Status</p>
                      <input type="text" className="box small" value={updStatus} style={{ "marginTop": "0px" }} />
                      {/*
                      <select className="small"
                        onChange={(e) => setupdStatus(e.target.value)} style={{ "marginTop": "0px" }}
                        value={updStatus}>
                        <option value="OK">OK</option>
                        <option value="Damaged">Damaged</option>
                        <option value="Required Repair">Required Repair</option>
                        <option value="Returned to Vendor">Returned to Vendor</option>
                      </select>
                      */}
                      <p style={{ "fontSize": ".65rem" }}>Quantity</p>
                      <input type="text" className="box small" value={updQty} style={{ "marginTop": "0px" }} />

                      <p style={{ "fontSize": ".65rem" }}>Dt.of Repair</p>
                      <input type="date" className="custom__date" value={updDor} style={{ "marginTop": "0px" }} />

                      <label>
                        <p style={{ "fontSize": ".65rem" }}>Require Calibration</p> 
                        <input checked={calibration} type="checkbox" /> 
                      </label>
                    </div>

                  </div>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        </div>
      </div>
    </div>
  );
}

export default ToolMaster;

